import { render, staticRenderFns } from "./CodeJSONPermission.vue?vue&type=template&id=33ee69f0"
import script from "./CodeJSONPermission.vue?vue&type=script&lang=ts"
export * from "./CodeJSONPermission.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports